import React, { useRef } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { Icon } from "components/Icon/Icon";
import { TranslateWrapper } from "components/TranslateWrapper";

type Props = {
  tooltipText: React.ReactNode;
};

export const InfoTooltip = ({ tooltipText }: Props) => {
  const iconRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div ref={iconRef}>
        <Icon
          className="ms-2 text-gray-600 cursor-pointer"
          iconName="circle-info-regular"
          tabIndex={-1}
        />
      </div>
      <UncontrolledTooltip
        target={iconRef as React.RefObject<HTMLElement>}
        placement="top"
        autohide={false}
      >
        {tooltipText}
      </UncontrolledTooltip>

      {typeof tooltipText === "object" && (
        <TranslateWrapper
          tooltipId={iconRef as React.RefObject<HTMLElement>}
          tooltipText={
            (tooltipText as React.ReactElement<{ tooltipText: string }>).props
              .tooltipText
          }
          placement="bottom"
        />
      )}
    </>
  );
};
